// Shared scripting (AtlasScript) help content, reused by the editor's Help
// modal and the expandable section in the form editor's Help guide.
export default function ScriptingHelp() {
    const cat = (color, name, desc) => (
        <li>
            <span style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: 2,
                background: color,
                border: '1px solid rgba(0,0,0,.15)',
                marginRight: 8,
                verticalAlign: 'middle'
            }}></span>
            <b>{name}</b> — {desc}
        </li>
    );

    return (
        <div style={{ lineHeight: 1.55 }}>
            <p style={{ color: 'var(--ed-text-soft)', marginTop: 0 }}>
                Scripting (AtlasScript) adds dynamic behavior to a form element using visual
                blocks. Everything is a “command”, and commands nest inside one another through
                their children.
            </p>

            <h3 className="help-h">Events — when a script runs</h3>
            <ul className="help-ul">
                <li><b>On Start</b> — when the record is opened.</li>
                <li><b>On Change</b> — when this element changes.</li>
                <li><b>On Save</b> — when the record is saved.</li>
            </ul>
            <p style={{ color: 'var(--ed-text-soft)' }}>
                Choose the event with the tabs at the top of the editor. Only events can sit at
                the top level — everything else nests inside them.
            </p>

            <h3 className="help-h">Building a script</h3>
            <ul className="help-ul">
                <li>Drag blocks from the palette on the left into the event canvas.</li>
                <li>Nest commands inside one another to build logic, and fill in each block's fields and expression slots.</li>
                <li>Drill into a block to focus on it, and use Undo / Redo, zoom, and Import / Export from the toolbar.</li>
            </ul>

            <h3 className="help-h">Command types</h3>
            <ul className="help-ul">
                {cat('#FAF3DD', 'Events', 'run their children when the event fires.')}
                {cat('#55efc4', 'Conditionals', 'take a boolean and run their children only when it is true.')}
                {cat('#74b9ff', 'Expressions', 'produce a value — a constant, or a field’s value.')}
                {cat('#ff7675', 'Operators', 'compare values and return true / false (e.g. >, <, =).')}
                {cat('#dfe6e9', 'Signals', 'do something the user sees, like showing an error or disabling a field.')}
                {cat('#a29bfe', 'Variables', 'read and write the form’s variables so elements can react to each other.')}
            </ul>

            <h3 className="help-h">Good to know</h3>
            <ul className="help-ul">
                <li>Scripts are saved per element; with several elements selected you can apply one shared script to all of them.</li>
                <li>“Link” keeps On Start and On Change in sync, “Clear All” empties every event, and “Done” saves and closes.</li>
            </ul>
        </div>
    );
}
